<template>
  <v-container grid-list-xl>
    <v-layout wrap>
      <v-col xs12>
        <v-card>
          <v-card-title primary-title>
            <v-img src="@/assets/alba-logo.png" height="50" contain />
          </v-card-title>
          <v-card-text class="text-center">
            <p v-if="user.email.includes('@albademo.com')">
              You have been automatically granted access to the app.
              <br />Click the button below to continue.
            </p>
            <p v-else>
              Please wait until your profile is approved by administration.
              <br />Once approved click below to gain access.
            </p>
            <v-btn color="primary" @click="checkForAccess" :loading="loading" :disabled="loading">
              <span v-if="user.email.includes('@albademo.com')">Access Alba App</span>
              <span v-else>Check if access has been approved</span>
            </v-btn>
            <br />
            <br />
            <v-btn color="primary" text small @click="signout">signout</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-layout>
  </v-container>
</template>


<script>
import fb from "@/main";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState(["user"])
  },
  methods: {
    async checkForAccess() {
      try {
        await fb.auth.currentUser.getIdTokenResult(true);
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.$router.push("/");
        }, 2000);
      } catch (error) {
        alert("An error occured.");
        console.log(error);
      }
    },
    signout: async function() {
      try {
        await fb.auth.signOut();
        this.$router.push("/login");
      } catch (error) {
        alert(error);
      }
    }
  }
};
</script>